import { Component } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { PLATFORM_ID, Inject, OnInit } from '@angular/core';
import { MobileUiService } from './shared/services/mobile-ui.service';
import { getBrowserHostname, resolveRuntimeMode } from './shared/services/runtime-mode.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  showTestBanner = false;
  testBannerText = '';

  constructor(
    public breakpointObserver: BreakpointObserver,
    private mobileUiService: MobileUiService,
    @Inject(PLATFORM_ID) private platformId: object) {
    this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.HandsetPortrait])
      .subscribe((state: BreakpointState) => {
        this.mobileUiService.isMobile.next(state.matches);
      });
  }

  ngOnInit(): void {
    this.setTestBannerState();
  }

  private setTestBannerState(): void {
    const hostLabelMap = new Map<string, string>([
      ['profile.qa.apps.unthsc.edu', 'TEST SITE (Data is not accurate because its a test site)'],
      ['profile.uat.apps.unthsc.edu', 'TEST SITE (Data is not accurate because its a test site)']
    ]);
    const defaultBannerLabel = 'TEST SITE (Data is not accurate because its a test site)';

    if (isPlatformBrowser(this.platformId)) {
      const hostname = getBrowserHostname();
      const runtimeMode = resolveRuntimeMode(hostname);

      if (runtimeMode !== 'production') {
        const hostBannerLabel = hostLabelMap.get(hostname);
        this.showTestBanner = true;
        this.testBannerText = hostBannerLabel || defaultBannerLabel;
        return;
      }
    }

    this.showTestBanner = false;
    this.testBannerText = '';
  }
}
